import { ButtonSimple } from '@jollywise/jollygoodgame/src/input/ButtonSimple';
import { PriceTag } from '../display/ui/PriceTag';

export class ItemSelectButton extends Phaser.GameObjects.Container {
  constructor(scene, config) {
    super(scene);

    this.id = config.id;
    this.config = config;

    // background panel
    this.panel = scene.add
      .image(0, 0, 'graphics', 'item_select_bg' + (config.locked ? '_locked' : ''))
      .setOrigin(0.5, 1);

    // thumbnail image
    this.thumb = scene.add
      .image(
        0,
        0,
        config.thumb?.sheet || 'character_thumbs',
        config.thumb?.frame || 'char_thumb_' + config.id
      )
      .setOrigin(0.5, 1);

    // actual button
    this.btn = new ButtonSimple(scene, {
      x: 0,
      y: 0,
      id: config.id,
      costume: 'item_select_frame',
      sheet: 'graphics',
      clickSFX: { sprite: 'sfx', id: 'unlock_select' },
    });
    this.btn.on('click', this.dispatchSelect, this);
    this.btn.setOrigin(0.5, 1);

    // label
    this.label = scene.add.image(
      10,
      -this.panel.height,
      'locale_text',
      config.label + (config.locked ? '_locked' : '')
    );

    // add cildren
    this.add([this.panel, this.thumb, this.btn, this.label]);

    // price tag if cost assigned
    if (config.locked && config.cost) {
      this.price = new PriceTag(scene, config.cost);
      this.price.x = 20;
      this.price.y = 0;
      this.locked = scene.add.image(0, -this.panel.height * 0.5, 'graphics', 'icon_locked');
      this.add([this.price, this.locked]);
    }
    // position self

    this.x = config.x;
    this.y = config.y;
    scene.add.existing(this);
  }

  get type() {
    return this.config.type || 'character';
  }

  get cost() {
    return this.config.cost;
  }

  unlock() {
    this.panel.setFrame('item_select_bg');
    this.label.setFrame(this.config.label);
    if (this.price) {
      this.price.destroy();
      this.price = null;
    }
    if (this.locked) {
      this.locked.destroy();
      this.locked = null;
    }
  }

  dispatchSelect() {
    this.emit('click', this);
  }
}
